import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../../i18n/runtime";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
export default function ContentPage() {
  __useLocale();
  const {
    token
  } = useAuth();
  const [data, setData] = useState({});
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [ready, setReady] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setReady(false);
    axios.get('/api/settings.php?category=content', {
      headers: {
        Authorization: `Bearer ${token}`
      },
      signal: controller.signal
    }).then(res => {
      setData(res.data);
      setReady(true);
      setMessage('');
    }).catch(() => {
      if (!controller.signal.aborted) setMessage(__tr("تعذر تحميل المحتوى"));
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    return () => controller.abort();
  }, [token, attempt]);
  return <form className="bg-white p-6 rounded-xl space-y-4" dir={__direction()} onSubmit={async e => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put('/api/settings.php?category=content', data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setMessage(__tr("تم الحفظ"));
    } catch {
      setMessage(__tr("تعذر الحفظ"));
    } finally {
      setSaving(false);
    }
  }}><h2 className="font-bold text-xl">{__tr("محتوى الموقع")}</h2><p role="status">{__tr(loading ? "جارٍ التحميل…" : message)}</p>
    {__tr(!ready && !loading && <button type="button" onClick={() => setAttempt(n => n + 1)}>{__tr("إعادة المحاولة")}</button>)}
    {__tr([['news', "الأخبار"], ['faq', "الأسئلة الشائعة"], ['terms', "الشروط والأحكام"], ['privacy', "سياسة الخصوصية"], ['news_en', 'News (English)'], ['faq_en', 'FAQ (English)'], ['terms_en', 'Terms (English)'], ['privacy_en', 'Privacy (English)']].map(([key, label]) => <label className="block" key={key}>{__tr(label)}<textarea disabled={!ready || saving} rows={5} className="block w-full border rounded p-3" value={data[key] || ''} onChange={e => setData({
        ...data,
        [key]: e.target.value
      })} /></label>))}
    <button disabled={!ready || saving} className="bg-[#6B5B95] text-white px-6 py-2 rounded">{__tr("حفظ")}</button>
  </form>;
}
